module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "log-header"
  }, [_c('div', {
    staticClass: "log-container"
  }, [_c('div', {
    staticClass: "brand"
  }, [_c('img', {
    attrs: {
      "src": _vm.brand,
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "log-welcome"
  }, [_vm._v("选择店铺")])])]), _vm._v(" "), _c('div', {
    staticClass: "log-container"
  }, [_c('el-table', {
    staticClass: "admin-data-table",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.list,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "class-name": "admin-cell-title",
      "prop": "name",
      "label": "店铺名称",
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "是否启用"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.is_valid == 'true') ? _c('el-tag', {
          attrs: {
            "type": "success"
          }
        }, [_vm._v("启用")]) : _c('el-tag', {
          attrs: {
            "type": "info"
          }
        }, [_vm._v("禁用")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "店铺地址"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(scope.row.store_address) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "创建时间"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm._f("datetime")(scope.row.created, 'yyyy-MM-dd')))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.selectDistributor(scope.row)
            }
          }
        }, [_vm._v("进入店铺")])]
      }
    }])
  })], 1)], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-cfd31442", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cfd31442"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/shoplist.vue
// module id = 1042
// module chunks = 30